import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Services from './components/Services';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import NotFound from './components/NotFound';
import About from './components/About';
import Contact from './components/Contact';
import Blogs from './components/Blogs';
import ProductDetails from './components/ProductDetails';
import Product from './components/Product';
import DeckleMatchingGuide from './components/blogs/DeckleMatchingGuide';
import ReduceTrimWaste from './components/blogs/ReduceTrimWaste';
import MistakesInReelSlitting from './components/blogs/MistakesInReelSlitting';
import WhyDeckleMatchingOptimization from './components/blogs/WhyDeckleMatchingOptimization';
import DeckleProImprovesYield from './components/blogs/DeckleProImprovesYield';
import DeckleMatchingSoftwareFeatures from './components/blogs/DeckleMatchingSoftwareFeatures';
import ManualVsSoftwareDeckleMatching from './components/blogs/ManualVsSoftwareDeckleMatching';
import GSMDeckleKnifeLimits from './components/blogs/GSMDeckleKnifeLimits';
import HowReduced18PercentWaste from './components/blogs/HowReduced18PercentWaste';
import DotNet10 from './components/blogs/DotNet10';
import AngularMostReliableFramework from './components/blogs/AngularMostReliableFramework';
import NodeIsBackbone from './components/blogs/NodeIsBackbone';
import ArchitectingAngularApplications from './components/blogs/ArchitectingAngularApplications';
import WhySaasProductsSlowDown from './components/blogs/WhySaaSProductsSlowDown';
import ModernizingLegacyWithDotNetCore from './components/blogs/ModernizingLegacyWithDotNetCore';
import EngineeringPartnerVsHiring from './components/blogs/EngineeringPartnerVsHiring';
import FoundersGuideReliableSoftware from './components/blogs/FoundersGuideReliableSoftware';

const App = () => {
  return (
    <div>
      <Header />
      <main id="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Product />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/deckle-matching-guide" element={<DeckleMatchingGuide />} />
          <Route path="/blogs/reduce-trim-waste" element={<ReduceTrimWaste />} />
          <Route path="/blogs/mistakes-in-reel-slitting" element={<MistakesInReelSlitting />} />
          <Route path="/blogs/deckle-matching-optimization" element={<WhyDeckleMatchingOptimization />} />
          <Route path="/blogs/manual-vs-software-deckle-matching" element={<ManualVsSoftwareDeckleMatching />} />
          <Route path="/blogs/gsm-deckle-knife-limits" element={<GSMDeckleKnifeLimits />} />
          <Route path="/blogs/decklepro-improves-yield" element={<DeckleProImprovesYield />} />
          <Route path="/blogs/deckle-matching-software-features" element={<DeckleMatchingSoftwareFeatures />} />
          <Route path="/blogs/how-reduced-18-percent-waste" element={<HowReduced18PercentWaste />} />
          <Route path="/blogs/dotnet-10-business-solutions" element={<DotNet10 />} />
          <Route path="/blogs/angular-most-reliable-framework" element={<AngularMostReliableFramework />} />
          <Route path="/blogs/node-is-backbone" element={<NodeIsBackbone />} />
          <Route path="/blogs/architecting-angular-applications" element={<ArchitectingAngularApplications />} />
          <Route path="/blogs/why-saas-products-slow-down" element={<WhySaasProductsSlowDown />} />
          <Route path="/blogs/modernizing-legacy-with-dotnet-core" element={<ModernizingLegacyWithDotNetCore />} />
          <Route path="/blogs/engineering-partner-vs-hiring" element={<EngineeringPartnerVsHiring />} />
          <Route path="/blogs/founders-guide-reliable-software" element={<FoundersGuideReliableSoftware />} />
          <Route path="/product-details" element={<ProductDetails />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
